export const PLAN_PRICE_MIN = 0;
export const PLAN_PRICE_MAX = 9_999_999_999.99;

export function validatePlanPrice(price: number): string | null
{
  if (!Number.isFinite(price))
  {
    return 'Informe um valor de preço válido.';
  }

  if (price < PLAN_PRICE_MIN)
  {
    return 'O preço não pode ser negativo.';
  }

  if (price > PLAN_PRICE_MAX)
  {
    return 'O valor informado excede o limite permitido.';
  }

  return null;
}
